import { render, staticRenderFns } from "./ChatGptProofreading.vue?vue&type=template&id=747f750f"
import script from "./ChatGptProofreading.vue?vue&type=script&lang=ts"
export * from "./ChatGptProofreading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports